"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DwarfIcon = _interopRequireDefault(require("./DwarfIcon"));
var _default = (0, _styledComponents["default"])(_DwarfIcon["default"]).attrs({
  role: 'presentation'
}).withConfig({
  displayName: "CloseInverse",
  componentId: "sc-1y6mvuu-0"
})(["background-position:-335px -260px;cursor:pointer;"]);
exports["default"] = _default;
//# sourceMappingURL=CloseInverse.js.map